export interface IHttpResponse<T> extends Response {
  parsedBody?: T;
}

class VincentricServices {
  getComparation = <T>(
    request: string,
    distance: string,
    trim_id: string,
  ): Promise<IHttpResponse<T>> => {
    return new Promise((resolve, reject) => {
      let response: IHttpResponse<T>;
      const path: RequestInfo = request
        .replace('{distance}', distance)
        .replace('{trim_id}', trim_id);
      const abortController = new AbortController();
      fetch(path, {signal: abortController.signal})
        .then((res) => {
          response = res;
          return res.json();
        })
        .then((body) => {
          if (response.ok) {
            response.parsedBody = body;
            resolve(response);
            abortController.abort();
          } else {
            reject(response);
          }
        })

        .catch((err) => {
          reject(err);
        });
    });
  };

  getModelName = <T>(
    request: string,
    sales_code: string,
    year: string,
    lang = 'en',
  ): Promise<IHttpResponse<T>> => {
    return new Promise((resolve, reject) => {
      let response: IHttpResponse<T>;
      const path: RequestInfo = request
        .replace('{sales_code}', sales_code)
        .replace('{year}', year)
        .replace('{lang}', lang);
      fetch(path)
        .then((res) => {
          response = res;
          return res.json();
        })
        .then((body) => {
          if (response.ok) {
            response.parsedBody = body;
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
}

export default VincentricServices;
